import { styled } from '@mui/material';

export const Container = styled('section')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '30px 16px',
  gap: '8px',
  flex: '1 0 0',
  background: '#FFF',
  width: '100%',
  marginTop: -16,

  '& svg': {
    height: '32px',
    width: '32px',
    color: '#98A2B3',
  },

  '& p': {
    color: '#475467',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '148%',
  },
}));
